module.exports = __webpack_public_path__ + "img/0Q3B3739_BlackMatted.4e5164b2.jpg";